import { render, staticRenderFns } from "./WorkAuctions.vue?vue&type=template&id=5b663eb0&lang=pug&"
import script from "./WorkAuctions.vue?vue&type=script&lang=js&"
export * from "./WorkAuctions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports